import { useEffect } from "react";
import { Helmet } from "react-helmet-async";

import "../cards/indexV1/indexV1.css";
import "../cards/indexV1/animations";
import "../cards/indexV1/marketingAnalytics";
import "../cards/indexV1/planModal";
import TrustStrip from "../cards/indexV1/TrustStrip";
import StudentSection from "../cards/indexV1/StudentSection";
import ParentSection from "../cards/indexV1/ParentSection";
import PlansSection from "../cards/indexV1/PlansSection";
import HowItWorksSection from "../cards/indexV1/HowItWorksSection";
import PricingSection from "../cards/indexV1/PricingSection";
import FinalCtaSection from "../cards/indexV1/FinalCtaSection";

const SEO_TITLE =
  "Learnforest — AI Study Plans & Curated Learning Videos for K-12";
const SEO_DESCRIPTION =
  "AI study plans with curated YouTube videos for K-12 learning. No ads, no distractions—just focused education for students with parent oversight.";
const SEO_SOCIAL_TITLE = "Learnforest — AI Study Plans for K-12 Learning";
const SEO_SOCIAL_DESCRIPTION =
  "Create personalized study plans with curated YouTube videos. No ads, no distractions—just focused learning for students with parent oversight.";
const SEO_URL = "https://learnforest.app/";
const SEO_IMAGE = "https://learnforest.app/intro.png";
const SEO_LOGO = "https://learnforest.app/logo-fish.png";

const ORGANIZATION_JSON_LD = JSON.stringify({
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Learnforest",
  url: SEO_URL,
  logo: SEO_LOGO,
});

function IndexPageV1() {
  useEffect(() => {
    if (typeof window !== "undefined" && window.__iv1RunAnimations) {
      window.__iv1RunAnimations();
    }
    if (typeof window !== "undefined" && window.__lfMarketingAnalyticsRun) {
      // Mark as run so the auto-bootstrap inside the module is a no-op.
      window.__lfMarketingAnalyticsRan = true;
      window.__lfMarketingAnalyticsRun({ routeId: "marketing_home" });
    }
    if (typeof window !== "undefined" && window.__iv1WirePlanModals) {
      window.__iv1WirePlanModals();
    }
  }, []);

  return (
    <div className="flex flex-col text-left">
      <Helmet>
        <title>{SEO_TITLE}</title>
        <meta name="description" content={SEO_DESCRIPTION} />
        <link rel="canonical" href={SEO_URL} />
        <meta property="og:title" content={SEO_SOCIAL_TITLE} />
        <meta property="og:description" content={SEO_SOCIAL_DESCRIPTION} />
        <meta property="og:url" content={SEO_URL} />
        <meta property="og:type" content="website" />
        <meta property="og:image" content={SEO_IMAGE} />
        <meta property="og:site_name" content="Learnforest" />
        <meta property="og:locale" content="en_US" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={SEO_SOCIAL_TITLE} />
        <meta name="twitter:description" content={SEO_SOCIAL_DESCRIPTION} />
        <meta name="twitter:image" content={SEO_IMAGE} />
        <script type="application/ld+json">{ORGANIZATION_JSON_LD}</script>
      </Helmet>
      <TrustStrip />
      <StudentSection />
      <ParentSection />
      <PlansSection />
      <HowItWorksSection />
      <PricingSection />
      <FinalCtaSection />
    </div>
  );
}

export default IndexPageV1;
